import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';

import { prototypePageConfigs } from './prototypeData';

// TODO(coming-soon-bypass): Temporary reusable placeholder. Delete when the
// bypass is fully reverted (see src/pages/admin/_temp/comingSoonConfig.ts).
export function AdminComingSoonPage() {
  const { pathname } = useLocation();
  const { t } = useTranslation('common');

  const titleKey =
    pathname === '/home'
      ? 'navigation.home'
      : prototypePageConfigs.find((config) => config.path === pathname)?.titleKey;

  const menuTitle = titleKey ? t(titleKey) : '';

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{menuTitle}</h1>
        </div>
      </div>
      <div className="content__body">
        <div className="empty-state" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '64px 16px', textAlign: 'center' }}>
          <Clock size={40} />
          <strong style={{ fontSize: 18 }}>{t('comingSoon.title')}</strong>
          <p>{t('comingSoon.subtitle')}</p>
        </div>
      </div>
    </>
  );
}
